import { ExpenseImage } from './expense-image.model';
import { AutoApprovalResult, ExpenseCategoryType, ExpenseClaimState } from './expense.model';
import {
  ExpenseRuleListItemViewModel,
  MileageRateListItemViewModel
} from "app/features/trial/trial-details/trial-policy.model";

export class ExpenseCheck {
  public policyReminders: string;
  public notes: string;
  public internalNotes: string;
  public overspendApproved: boolean;
  public bankFeesIncurred: boolean;
  public fixedFeePerVisit: boolean;
  public overspendTravel: boolean;
  public overspendMileage: boolean;
  public approvalNoReceipts: boolean;
  public trialExpensePolicyReminders: string;
  public visitExpenseClaims: ExpenseCheckClaim[];
  public subTotals: ExpenseCheckSubTotal[];
  public internalPolicyNotes: string;
  public amount: number;
  public currency: string;
  public visitLengthInDays: number;
  public overBudgetRequestRaised: boolean;
  public expenseCategoryType: ExpenseCategoryType;
  public approvalSuggestion?: AutoApprovalResult;
  public caregiverTravelling: string;
  public visitAttendance: string;
  public overBudgetRequestRuleExists: boolean;
  public referredBack: boolean;
  public visitBookingStatus: string;
  public visitTravelDays: number;
  public patientStateOnTrial: string;
  public rules: ExpenseRuleListItemViewModel[];
  public rates: MileageRateListItemViewModel[];
  public trialPolicyId: string;
  public trialPolicyCountry: string;
  public trialPolicyName: string;
}

export class ExpenseCheckSubTotal {
  public categoryName: string;
  public currency: string;
  public approved: number;
  public pending: number;
  public total: number;
}

export class ExpenseCheckClaim {
  public id: string;
  public created: Date;
  public dateApproved: Date;
  public dateRejected: Date;
  public datePaid: Date;
  public state?: string;
  public notes: string;
  public categoryType: string;
  public categoryName: string;
  public subCategoryName: string;
  public currency: string;
  public amount: number;
	public distanceUnit: string;
  public distanceAmount: number;
  public imageUrls: ExpenseImage[]
  public underInvestigation: boolean;
  public addedByPatient: boolean;
  public reasonForInvestigation: string;
  public rejectionReason: string;
}

export enum CaregiverTravelling {
  No = 0,
  Yes = 1,
  TravelBooked = 3
}

export class CaregiverTravellingString {
  static Values: { [key in CaregiverTravelling]: string } = {
    [CaregiverTravelling.No]: "No or Not Applicable",
    [CaregiverTravelling.Yes]: "Yes",
    [CaregiverTravelling.TravelBooked]: "Travel Booked",
  };
}
